/**
 * config.js
 *
 * ⚠️  BEFORE RUNNING: replace DEVELOPER_TOKEN with your own JWT.
 *
 * How to generate one:
 *   1. Sign in to developer.apple.com → Certificates, Identifiers & Profiles
 *   2. Under Keys, create a new key with "MusicKit" checked.
 *      Download the .p8 private key file.
 *   3. Note your Team ID (top-right corner of the portal) and the Key ID.
 *   4. Use the script in scripts/generate-token.mjs (included in this repo)
 *      to sign a JWT:
 *
 *        node scripts/generate-token.mjs \
 *          --team-id  XXXXXXXXXX \
 *          --key-id   YYYYYYYYYY \
 *          --key-file AuthKey_YYYYYYYYYY.p8
 *
 *   5. Paste the output token below. Tokens expire after 180 days max.
 *
 * Reference:
 *   https://developer.apple.com/documentation/applemusicapi/generating-developer-tokens
 */

export const DEVELOPER_TOKEN = 'eyJhbGciOiJFUzI1NiIsImtpZCI6IjZNNUQ4UFYzWUgiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJTUVIyNzNITDVUIiwiaWF0IjoxNzczOTcxNjE5LCJleHAiOjE3ODk3NDg2MTl9.FVPji4gHjoikYNCJbhqgD7veLV0HINVz93IbxJY-rd2ud-5-5v5O2o07yDxLcVyGIKnBXDmKTKF3-0VFItg4SA';

/**
 * Spotify Client ID — from https://developer.spotify.com/dashboard
 * 1. Create an app in the Spotify Developer Dashboard
 * 2. Add your deployed URL to "Redirect URIs" (e.g. https://yourapp.vercel.app/)
 * 3. Paste the Client ID below.
 * Note: Spotify Web Playback requires a Spotify Premium account.
 */
export const SPOTIFY_CLIENT_ID = 'b6974709e1494627a9d1320069c2076a';
